import { Flex } from "@chakra-ui/react";
import { Messages } from "../../../../../../../core/api";
import BaselinePersonIcon from "../../../../../../../shared/icons/BaselinePersonIcon";
import { dateFormatter } from "../../../../../../../shared/utils/date-formatter";
import CallTicketIndexBadge from "../../../../CallTicketIndexBadge";
import CallTicketText from "../../CallTicketText";
import { getParticipantDescription } from "../call-ticket-event-utils";

interface Props {
  event: Messages["TelephonyCallParticipantEvent"] & { data: { name: "Answered" | "Joined" } };
}

const CallTicketEventCardAnswer = ({ event }: Props) => {
  return (
    <Flex alignItems="center" gap={2}>
      <CallTicketIndexBadge>
        <BaselinePersonIcon />
      </CallTicketIndexBadge>
      <Flex direction="column">
        <CallTicketText color="gray.400">
          {dateFormatter.toDateTime(event.timestamp)}
        </CallTicketText>
        <Flex gap={1}>
          <CallTicketText fontWeight="bold">
            {getParticipantDescription(event.data.participant)}
          </CallTicketText>
          <CallTicketText>has answered the call.</CallTicketText>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CallTicketEventCardAnswer;
